import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

interface CheckedItemContainerProps {
  hasText: boolean;
}

export const CheckedItemContainer = styled.div<CheckedItemContainerProps>`
  margin: 1rem auto;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: flex-start;

  svg {
    max-width: 40px;
    min-width: 40px;
    height: 40px;

    ${({ hasText }) => !hasText ? '' : css`
      margin-right: 1rem;
    `}

    @media screen and (max-width: ${layout.subLg}) {
      max-width: 28px;
      min-width: 28px;
      height: 28px;
    }
  }
`
